import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from './menu'
import errores from '../middleware/errordb'
import back from '../back.svg';
import config from '../config';
import Mensajes from './subcomponent/mensajes';
import ModalConfirm from './subcomponent/modalConfirm';

class FormularioUsuario extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('_id');
        this.state = {
            titulo: "Crear Usuarios",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            empresa: currentCompany,
            codEmp: "",
            nombre: "",
            id_usuario: "",
            usuario: "",
            password: "",
            tipo: currentUserType,
            usuario_login: currentUser,
            estado: "1",
            tipo_usuario: "1",
            mensaje: "",
            vendedores: [],
            vendedor_asociado: "0",
            isfacele: false,
            iscatalogo: false,
            isestrutura: false,
            isventas: false,
            ispedido: false,
            isadmpedido:false,
            ispos: false,
            isinventario: false,
            activefacele: true,
            activecatalogo: true,
            activeestrutura: true,
            activeventas: true,
            activepedido: true,
            activeinventario: true,
            activepos: true,
            activeadmpedido:false
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_usuario = "";
        const usuarioEdicion = search.replace('?', '');
        const { usuario_login } = this.state;
        const { empresa } = this.state;
        if (usuarioEdicion) {
            titulo = "Modificar Usuarios";
            id_usuario = usuarioEdicion;
        } else {
            titulo = "Crear Usuarios";
            id_usuario = "";
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                id_usuario,
                usuario_login
            }),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/users/', datasend).then(response => response.json())
            .then(data => {
                const datos = data.data;
                const usuario = datos[0];
                const perm = datos[1];
                const vend = datos[2];
                // console.log(datos);
                if (usuario.length > 0) {
                    this.setState({
                        codEmp: usuario[0]["CODIGO_EMPRESA"],
                        nombre: usuario[0]["NOMBRE_COMPLETO"],
                        usuario: usuario[0]["USUARIO"],
                        id_usuario: usuario[0]["ID_USUARIO"],
                        password: usuario[0]["PASSWORD"],
                        estado: usuario[0]["ESTADO"],
                        tipo_usuario: usuario[0]["TIPO_USUARIO"],
                        vendedor_asociado: usuario[0]["VENDEDOR_ASOCIADO"],
                        isfacele: usuario[0]["FACTURACION_ELECTRONICA"],
                        iscatalogo: usuario[0]["CATALOGO"],
                        isestrutura: usuario[0]["ESTRUCTURACION"],
                        isventas: usuario[0]["VENTAS"],
                        ispedido: usuario[0]["PEDIDOS"],                        
                        isadmpedido: usuario[0]["ADMIN_PEDIDOS"],
                        ispos: usuario[0]["POS"],
                        isinventario: usuario[0]["INVENTARIO"],
                        activefacele: perm[0]["FACTURACION_ELECTRONICA"],
                        activecatalogo: perm[0]["CATALOGO"],
                        activeestrutura: perm[0]["ESTRUCTURACION"],
                        activeventas: perm[0]["VENTAS"],
                        activepedido: perm[0]["PEDIDOS"],
                        activeadmpedido: perm[0]["ADMIN_PEDIDOS"],
                        activeinventario: perm[0]["INVENTARIO"],
                        activepos: perm[0]["POS"]
                    })
                }
                this.setState({
                    vendedores: vend,
                    activefacele: perm[0]["FACTURACION_ELECTRONICA"],
                    activecatalogo: perm[0]["CATALOGO"],
                    activeestrutura: perm[0]["ESTRUCTURACION"],
                    activeventas: perm[0]["VENTAS"],
                    activepedido: perm[0]["PEDIDOS"],
                    activeadmpedido: perm[0]["ADMIN_PEDIDOS"],
                    activeinventario: perm[0]["INVENTARIO"],
                    activepos: perm[0]["POS"]
                })
            });

        this.setState({ titulo, id_usuario });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state;
        const { codEmp } = this.state;
        const { nombre } = this.state;
        const { usuario } = this.state;
        const { password } = this.state;
        const { estado } = this.state;
        const { tipo_usuario } = this.state;
        const { vendedor_asociado } = this.state;
        const { isfacele } = this.state;
        const { iscatalogo } = this.state;
        const { isestrutura } = this.state;
        const { isventas } = this.state;
        const { ispedido } = this.state;
        const { isadmpedido } = this.state;
        const { isinventario } = this.state;
        const { ispos } = this.state;
        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                codEmp,
                nombre,
                usuario,
                password,
                estado,
                tipo_usuario,
                vendedor_asociado,
                isfacele,
                iscatalogo,
                isestrutura,
                isventas,
                ispedido,
                isinventario,
                ispos,
                isadmpedido
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_usuario === "") {
            ruta = config.servBackEnd + '/users/create'
        } else {
            ruta = config.servBackEnd + '/users/modify/' + this.state.id_usuario
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                ////console.log(data);
                if (data.ok) {
                    const nuevoUsuario = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_usuario;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_usuario: nuevoUsuario });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Usuario con errores:" + errores[data.code] + " " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
        event.preventDefault();
    }

    CheckedPerm = ({ target }) => {
        const { id } = target;
        const { checked } = target;
        this.setState({ [id]: checked });
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeBoton = (this.state.id_usuario === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_usuario === "") ? '¿Esta seguro que desea crear el usuario?' : '¿Esta seguro que desea modificar el usuario?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const { vendedores } = this.state;
        console.log(this.state.activeadmpedido)
        return (
            <div className="FormularioUsuario">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Usuarios!</Tooltip>}>
                            <div className="div-back">
                                <a href="/usuarios/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Control type="hidden" value={this.state.id_usuario} required disabled />
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled={!(this.state.tipo === '0')} />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridNombre">
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control type="text" placeholder="Nombre" onChange={e => this.setState({ nombre: e.target.value.toUpperCase() })} value={this.state.nombre} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridUsuario">
                                            <Form.Label>Usuario</Form.Label>
                                            <Form.Control type="text" placeholder="Usuario" onChange={e => this.setState({ usuario: e.target.value })} value={this.state.usuario} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridCodigoPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control type="password" placeholder="Password" onChange={e => this.setState({ password: e.target.value })} value={this.state.password} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="exampleForm.SelectCustom">
                                            <Form.Label>Tipo Usuario</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ tipo_usuario: e.target.value, vendedor_asociado: "0" })} value={this.state.tipo_usuario} required>
                                                <option value="1">Administrador</option>
                                                <option value="2">Gestor</option>
                                                <option value="3">Vendedor</option>
                                                <option value="4">Gestor Aprobador</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="exampleForm.SelectCustom">
                                            <Form.Label>Vendedor Asociado</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ vendedor_asociado: e.target.value })} value={this.state.vendedor_asociado}>
                                                <option value="0">Call Center</option>
                                                {
                                                    vendedores.map((vendedor, i) => {
                                                        return (
                                                            <option key={i} value={vendedor.ID_VENDEDORES}>{vendedor.NOMBRE_VENDEDOR}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridEstado">
                                            <Form.Label>Estado</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required>
                                                <option value="0">Inactivo</option>
                                                <option value="1">Activo</option>
                                            </Form.Control>
                                        </Form.Group>

                                    </Form.Row>
                                    <h3>PERMISOS</h3>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="isfacele">
                                            <Form.Check type="checkbox" label="FACTURACION ELECTRONICA" onChange={this.CheckedPerm} disabled={!this.state.activefacele} checked={this.state.isfacele} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="iscatalogo">
                                            <Form.Check type="checkbox" label="CATALOGO" onChange={this.CheckedPerm} disabled={!this.state.activecatalogo} checked={this.state.iscatalogo} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="isestrutura">
                                            <Form.Check type="checkbox" label="ESTRUCTURACION" onChange={this.CheckedPerm} disabled={!this.state.activeestrutura} checked={this.state.isestrutura} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="isventas">
                                            <Form.Check type="checkbox" label="VENTAS" onChange={this.CheckedPerm} disabled={!this.state.activeventas} checked={this.state.isventas} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ispedido">
                                            <Form.Check type="checkbox" label="PEDIDOS" onChange={this.CheckedPerm} disabled={!this.state.activepedido} checked={this.state.ispedido} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="isadmpedido">
                                            <Form.Check type="checkbox" label="GESTOR PEDIDOS" onChange={this.CheckedPerm} disabled={!this.state.activeadmpedido} checked={this.state.isadmpedido} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="isinventario">
                                            <Form.Check type="checkbox" label="INVENTARIO" onChange={this.CheckedPerm} disabled={!this.state.activeinventario} checked={this.state.isinventario} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ispos">
                                            <Form.Check type="checkbox" label="POS" onChange={this.CheckedPerm} disabled={!this.state.activepos} checked={this.state.ispos} />
                                        </Form.Group>
                                    </Form.Row>
                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioUsuario);





